const eyeColours = [
    { id: '47', name: 'Black' },
    { id: '48', name: 'Blue' },
    { id: '49', name: 'Brown' },
    { id: '50', name: 'Grey' },
    { id: '51', name: 'Green' },
    { id: '52', name: 'Hazel' },
    { id: '105', name: 'Blue/Green' },
    { id: '106', name: 'Blue/Grey' },
    { id: '107', name: 'Coloured Contact Lenses' }
];

export default eyeColours;



// WEBPACK FOOTER //
// ./src/data/eye-colours.js